import { get } from "lodash";

import st from "lib/utils/index";
import {
  STEP_AVAILABILITY,
  STEP_PRICELIST,
  STEP_PAYMENTS,
  STEP_DESCRIPTION,
  STEP_LOCATION,
  STEP_PHOTOS,
  STEP_PRICED_FIELDS,
  STEP_CUSTOMER_FIELDS,
  STEP_ADDITIONAL,
  STEP_BOOKING_SETTINGS,
  STEP_ACCOMMODATION_SETTINGS,
  ACCOMMODATION_UNIT_RANGES,
} from "./constants";

export function _validateStep({
  step: {
    params: { id },
  },
  product,
  errors,
  editedLocale,
}) {
  switch (id) {
    case STEP_DESCRIPTION:
      return (
        []
          .concat(
            product.translations
              // .filter(t => t.locale == editedLocale)
              .filter((t) => !errors.hasValidProp(`product.translations[${t.uuid}]`))
          )
          .concat(
            product.product_variants.filter(
              (pv) =>
                pv.translations
                  // .filter(pvt => pvt.locale == editedLocale)
                  .filter(
                    (pvt) => !errors.hasValidProp(`product.product_variants[${pv.uuid}].translations[${pvt.uuid}]`)
                  ).length > 0
            )
          ).length === 0
      );

    case STEP_CUSTOMER_FIELDS:
      return (
        [].concat(
          product.customer_fields.filter((pof) => !errors.hasValidProp(`product.product_order_fields[${pof.uuid}]`))
        ).length === 0
      );

    case STEP_PRICED_FIELDS:
      return (
        [].concat(
          product.priced_fields.filter((pof) => !errors.hasValidProp(`product.product_order_fields[${pof.uuid}]`))
        ).length === 0
      );

    case STEP_PRICELIST:
      return (
        [].concat(
          product.product_variants.filter(
            (pv) =>
              !errors.hasValidProp(`product.product_variants[${pv.uuid}].pricelist_type`) ||
              !errors.hasValidProp(`product.product_variants[${pv.uuid}].product_pricelist_items`)
          )
        ).length === 0
      );

    case STEP_ACCOMMODATION_SETTINGS:
      return (
        [].concat(
          product.product_variants.filter(
            (pv) =>
              product.product_type === "accommodation" &&
              (!errors.hasValidProp(`product.product_variants[${pv.uuid}].presented_price`) ||
                !errors.hasValidProp(`product.product_variants[${pv.uuid}].default_total_stock_limit`) ||
                !errors.hasValidProp(`product.product_variants[${pv.uuid}].accommodation_detail`))
          )
        ).length === 0
      );

    case STEP_PAYMENTS:
      return (
        [].concat(
          product.product_variants.filter(
            (pv) => !errors.hasValidProp(`product.product_variants[${pv.uuid}].payment_profile_product_attachments`)
          )
        ).length === 0
      );

    case STEP_LOCATION:
      return (
        errors.hasValidProp(`product.product_locations`) &&
        [].concat(
          product.product_variants.filter(
            (pv) => !errors.hasValidProp(`product.product_variants[${pv.uuid}].product_pickup_points`)
          )
        ).length === 0
      );

    default:
      return true;
  }
}

export const _validateProduct = (product, { submitValidate }) => {
  const errors = new st.form.ValidationErrors();

  product.marketplace_featured_price &&
    errors.add(
      `product.marketplace_featured_price`,
      st.validators.range(product.marketplace_featured_price.value, {
        greater_than_or_equal_to: 0,
      })
    );
  product.marketplace_featured_price_before_discount &&
    errors.add(
      `product.marketplace_featured_price_before_discount`,
      st.validators.range(product.marketplace_featured_price_before_discount.value, {
        greater_than_or_equal_to: (product.marketplace_featured_price && product.marketplace_featured_price.value) || 0,
      })
    );
  product.saas_featured_price &&
    errors.add(
      `product.saas_featured_price`,
      st.validators.range(product.saas_featured_price.value, {
        greater_than_or_equal_to: 0,
      })
    );
  product.saas_featured_price_before_discount &&
    errors.add(
      `product.saas_featured_price_before_discount`,
      st.validators.range(product.saas_featured_price_before_discount.value, {
        greater_than_or_equal_to: (product.saas_featured_price && product.saas_featured_price.value) || 0,
      })
    );

  product.translations.forEach((translation) => {
    errors.add(`product.translations[${translation.uuid}].name`, st.validators.presence(translation.name));
    errors.add(
      `product.translations[${translation.uuid}].name`,
      st.validators.length(translation.name, { minimum: 5, maximum: 100 })
    );
  });

  product.product_locations.forEach((location) => {
    errors.add(
      `product.product_locations[${location.uuid}].location`,
      st.validators.presence(location.location_name && location.location_lat && location.location_lng)
    );
    // location.translations.forEach(t => {
    //   errors.add(`product.product_locations[${location.uuid}].location`, st.validators.presence(t.location_name))
    // })
  });

  product.product_variants.forEach((pv) => {
    if (submitValidate && product.active) {
      product.has_pricing &&
        errors.add(`product.product_variants[${pv.uuid}].pricelist_type`, st.validators.presence(pv.pricelist_type));

      // product.has_pricing && errors.add(`product.product_variants[${pv.uuid}].payment_profile_product_attachments`,
      //   st.validators.presence(pv.payment_profile_product_attachments.filter(at => at.active))
      //     && "Wybierz chociaż jeden profil płatności."
      // )
    }
    pv.translations.forEach((t) => {
      if (product.product_variants.length > 1) {
        errors.add(`product.product_variants[${pv.uuid}].translations[${t.uuid}].name`, st.validators.presence(t.name));
        errors.add(
          `product.product_variants[${pv.uuid}].translations[${t.uuid}].name`,
          st.validators.length(t.name, { minimum: 5, maximum: 100 })
        );
      }
    });

    if (submitValidate && product.product_type === "accommodation") {
      const accommodationDetailsProps = [
        "category",
        "single_beds_count",
        "double_beds_count",
        "extra_beds_count",
        "bathrooms_count",
        "rooms_count",
      ];
      ["default_total_stock_limit", "presented_price"]
        .concat(accommodationDetailsProps.map((prop) => `accommodation_detail.${prop}`))
        .forEach((key) =>
          errors.add(`product.product_variants[${pv.uuid}].${key}`, st.validators.presence(get(pv, key)))
        );

      const validateAccommodationValueRange = (value, key, min, max) =>
        value &&
        errors.add(
          `product.product_variants[${pv.uuid}].${key}`,
          st.validators.range(value, {
            greater_than_or_equal_to: min,
            less_than_or_equal_to: max,
          })
        );
      validateAccommodationValueRange(
        pv.default_total_stock_limit,
        "default_total_stock_limit",
        0,
        ACCOMMODATION_UNIT_RANGES.MAX_DEFAULT_TOTAL_STOCK_LIMIT
      );
      pv.presented_price && validateAccommodationValueRange(pv.presented_price.value, "presented_price", 0);
      if (pv.accommodation_detail) {
        const validateAccommodationDetailPropsRange = (props, min, max) =>
          props.forEach((prop) =>
            validateAccommodationValueRange(pv.accommodation_detail[prop], `accommodation_detail.${prop}`, min, max)
          );
        validateAccommodationDetailPropsRange(
          ["single_beds_count", "double_beds_count", "extra_beds_count"],
          0,
          ACCOMMODATION_UNIT_RANGES.MAX_BEDS_COUNT
        );
        validateAccommodationDetailPropsRange(
          ["bathrooms_count", "rooms_count"],
          0,
          ACCOMMODATION_UNIT_RANGES.MAX_ROOMS_COUNT
        );
        validateAccommodationDetailPropsRange(["area"], 0);
      }
    }

    submitValidate &&
      product.has_pricing &&
      product.active &&
      errors.add(
        `product.product_variants[${pv.uuid}].product_pricelist_items`,
        st.validators.presence(pv.current_product_pricelist_items) &&
          I18n.t("activerecord.errors.models.product.product_pricelist_items_missing")
      );
    submitValidate &&
      product.has_pricing &&
      pv.current_product_pricelist_items.forEach((ppi) => {
        if (ppi.preset && ppi.preset.name !== "auto" && ppi.preset.name !== false) {
          errors.add(
            `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].name`,
            st.validators.presence(ppi.name)
          );
          // ppi.translations.forEach(t => {
          //   errors.add(`product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].name`, st.validators.presence(t.name))
          // })
        }
        if (ppi.preset && ppi.preset.pricelist_type === "pricelist_by_person") {
          errors.add(
            `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].min_persons_count`,
            st.validators.presence(ppi.min_persons_count)
          );
          errors.add(
            `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].max_persons_count`,
            st.validators.presence(ppi.max_persons_count)
          );
          errors.add(
            `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].min_persons_count`,
            st.validators.range(ppi.min_persons_count, {
              greater_than_or_equal_to: 1,
            })
          );
        }
        ppi.max_persons_count &&
          errors.add(
            `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].min_persons_count`,
            st.validators.presence(ppi.min_persons_count)
          );
        ppi.min_persons_count &&
          errors.add(
            `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].max_persons_count`,
            st.validators.presence(ppi.max_persons_count)
          );
        errors.add(
          `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].min_persons_count`,
          st.validators.range(ppi.min_persons_count, {
            greater_than_or_equal_to: 0,
          })
        );
        errors.add(
          `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].max_persons_count`,
          st.validators.range(ppi.max_persons_count, {
            greater_than_or_equal_to: ppi.min_persons_count || 0,
          })
        );
        errors.add(
          `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].min_person_age`,
          st.validators.range(ppi.min_person_age, {
            greater_than_or_equal_to: 0,
          })
        );
        errors.add(
          `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].max_person_age`,
          st.validators.range(ppi.max_person_age, {
            greater_than_or_equal_to: ppi.min_person_age || 0,
          })
        );
        errors.add(
          `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].price`,
          st.validators.presence(ppi.price)
        );
        errors.add(
          `product.product_variants[${pv.uuid}].product_pricelist_items[${ppi.uuid}].price`,
          st.validators.range(ppi.price && ppi.price.value, {
            greater_than_or_equal_to: 0,
          })
        );
      });

    pv.product_pickup_points.forEach((ppp) => {
      errors.add(
        `product.product_variants[${pv.uuid}].product_pickup_points[${ppp.uuid}].location`,
        st.validators.presence(ppp.location_name && ppp.location_lat && ppp.location_lng)
      );
      // ppp.translations.forEach(t => {
      //   errors.add(`product.product_variants[${pv.uuid}].product_pickup_points[${ppp.uuid}].location`, st.validators.presence(t.location_name))
      // })
    });
  });

  submitValidate &&
    product.product_order_fields.forEach((pof) => {
      errors.add(`product.product_order_fields[${pof.uuid}].name`, st.validators.presence(pof.name));
      // pof.translations.forEach(t => {
      //   errors.add(`product.product_order_fields[${pof.uuid}].name`, st.validators.presence(t.name))
      // })
      errors.add(`product.product_order_fields[${pof.uuid}].type`, st.validators.presence(pof.type));
      if (pof.type === "ProductOrderField::List") {
        errors.add(`product.product_order_fields[${pof.uuid}].list_options`, st.validators.presence(pof.list_options));
        pof.list_options &&
          pof.list_options.forEach((option) => {
            errors.add(
              `product.product_order_fields[${pof.uuid}].list_options[${option.uuid}].name`,
              st.validators.presence(option.name)
            );
            // option.translations.forEach(t => {
            //   errors.add(`product.product_order_fields[${pof.uuid}].list_options[${option.uuid}].name`, st.validators.presence(t.name))
            // })
            if (pof.has_pricing) {
              errors.add(
                `product.product_order_fields[${pof.uuid}].list_options[${option.uuid}].price`,
                st.validators.presence(option.price)
              );
            }
          });
      }
      if (pof.type === "ProductOrderField::Number") {
        if (pof.has_pricing) {
          errors.add(`product.product_order_fields[${pof.uuid}].min_value`, st.validators.presence(pof.min_value));
          errors.add(`product.product_order_fields[${pof.uuid}].max_value`, st.validators.presence(pof.max_value));
        }
        pof.min_value !== null &&
          errors.add(
            `product.product_order_fields[${pof.uuid}].max_value`,
            st.validators.range(pof.max_value, {
              greater_than_or_equal_to: pof.min_value,
            })
          );
      }
      if (pof.has_pricing && pof.type !== "ProductOrderField::List") {
        errors.add(`product.product_order_fields[${pof.uuid}].price`, st.validators.presence(pof.price));
      }
    });

  if (errors.length > 0) {
    errors.add("base", I18n.t("papp.common.form_validation_error_message"));
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/validate.js